import CategoryList from './CategoryList.component';

export default CategoryList;
